"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.queries = void 0;
exports.queries = {
    title: {
        interpretation: { vocab: "snomed", code: "184098006" }
    },
    firstName: {
        interpretation: { vocab: "snomed", code: "184095009" }
    },
    lastName: {
        interpretation: { vocab: "snomed", code: "184096005" }
    },
    socialSecurityNumber: {
        interpretation: { vocab: "snomed", code: "398093005" }
    },
    address: {
        interpretation: { vocab: "snomed", code: "184097001" }
    },
    phoneNumber: {
        interpretation: { vocab: "snomed", code: "734005006" }
    },
    dateOfBirth: {
        interpretation: { vocab: "snomed", code: "184099003" }
    },
    sex: {
        interpretation: { vocab: "snomed", code: "734000001" }
    },
    maidenNameOfMother: {
        interpretation: { vocab: "snomed", code: "423775007" }
    }
};
